<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>상품안내</li>
        <li>보험료 산출 및 납입</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>보험료 산출 및 납입</h2>
        <div class="depLink">
          <button type="button" title="메뉴">
            <span>보험료 산출 및 납입</span>
          </button>
          <ul>
            <li>
              <router-link to="/insursumCargoidm"
                ><span>적하보험의 개요</span></router-link
              >
            </li>
            <li>
              <router-link to="/cargotarProdguid"
                ><span>적하보험의 가입대상</span></router-link
              >
            </li>
            <li>
              <router-link to="/condcovProdguid"
                ><span>조건별 담보안내</span></router-link
              >
            </li>
            <li>
              <router-link to="/insurstrtProdguid"
                ><span>보험의 개시와 종료</span></router-link
              >
            </li>
            <li>
              <router-link to="/premcalProdguid"
                ><span>보험료 산출 및 납입</span></router-link
              >
            </li>
            <li>
              <router-link to="/blaninsurProdguid"
                ><span>포괄보험 안내</span></router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <h3 class="conTit">보험료 산출 및 납입</h3>

        <div class="conStyle1">
          <p class="tit">적하보험 보험료 산출</p>
          <p class="txt">
            품목별 기본 보험료에 계약자별 실적 및 포괄 보험 여부, 지역 또는 운송
            용구 할증, 인수 제한 등의 부가적 보험료 산정 요인 들이 반영되어 최종
            적용 보험료가 산출됩니다.
          </p>
          <ul class="line">
            <li>
              적하 보험료 산출방법 보험료 = Invoice 가격 × 110% × 보험 가입일의
              전신환 매도율 × 보험요율
            </li>
          </ul>

          <p class="tit">보험료의 납입</p>
          <p class="txt">
            품목별 기본 보험료에 계약자별 실적 및 포괄 보험 여부, 지역 또는 운송
            용구 할증, 인수 제한 등의 부가적 보험료 산정 요인 들이 반영되어 최종
            적용 보험료가 산출됩니다.<br />
            적하 보험 포괄계약(OP) 업체는 보험료 정산 특별 약정에 따라 보험자가
            작성한 일개월 동안 발생된 계약에 해당되는 보험료 청구서를 받은
            날로부터 10일 이내에 보험료를 납입하여야 합니다.
          </p>

          <p class="tit">품목별 적용 특성</p>
          <p class="txt">
            품목별 특성에 따라 보험조건이 제한되거나, 동일한 보험조건 내에서도
            특정 위험에 대한 담보는 제외되는 등 품목의 특성을 반영한 보험료 및
            조건 운영 특칙입니다. 해당 품목별 적용 특칙은 보험 계약 조건 입력시
            자동으로 적용되도록 조치되어 있으며, 따라서 보험 계약 청약 또는 보험
            증권 수령 시 특칙에 따른 제한 및 추가 담보 여부를 확인 하여야
            합니다.<br />
            예 : 유리 제품의 파손위험 부담보 등
          </p>

          <p class="tit">선박할증 보험료</p>
          <p class="txt">
            선급을 보유하지 않거나, 일정한 선령을 초과한 선박으로 운송되는
            화물에 대하여는 추가 보험료 및 보험 조건을 전제로 하여 담보가
            계속됩니다. 즉, 정기선은 선령이 만 26년 이상, 부정기선은 선령 만
            16년 이상인 경우 추가보험료가 적용됩니다.
          </p>

          <p class="txt">
            다음의 지역을 도착항 또는 목적지로 운송하는 화물 (비할증 지역으로
            운송하는 경우 포함)에 대하여 A/R, A/R(Air) 또는 부가위험 (T.P.N.D,
            Leakage/Shortage에 한함)을 첨부하여 인수하는 계약
          </p>

          <p class="tit">전쟁/동맹파업 위험 담보 특별약관</p>
          <p class="txt">
            적하보험에서 전쟁 및 동맹파업 위험은 담보되지 않으므로 담보를 원할
            경우 추가보험료를 납입하여야 합니다. 또한, 해당 적용 보험료는 지역별
            정치, 군사적 상황에 따라 수시로 변하므로 보험 계약 청약 시 보험사에
            문의하여야 합니다.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
</script>

<style></style>
